import { Modal, ModalProp } from "../../../components/modal/Modal";
import { Dialog } from "@headlessui/react";
import { OptionContract, nowDate } from "../../../model/OptionContract";
import Button from "../../../components/button/Button";
import { convertDateToString } from "../../../utility/ConvertUtily";
import { ConstMessage } from "../../../config/const";

type OptionCntractConfirmModalProps = {
  data?: OptionContract;
  onClickSubmit: (data: OptionContract) => Promise<void>;
};

export const OptionContractConfirmModal = ({
  open,
  toggle,
  closeOnClickOutside,
  data,
  onClickSubmit,
}: ModalProp & OptionCntractConfirmModalProps) => {
  
  const headerStyle = `whitespace-nowrap px-3 relative py-3.5 text-sm font-semibold text-left`;
  const bodyStyle = `whitespace-nowrap text-left px-3 py-4 text-sm text-gray-500`;

  const dispDate = (date: Date | null) => {
    const result = new Date(date ?? "")
    if(date !== null && !Number.isNaN(result.getTime())){
      return convertDateToString(result); 
    }else{
      return "";
    }
  }

  return(
    <Modal
      open={open}
      toggle={toggle}
      closeOnClickOutside={closeOnClickOutside}
    >
      <Dialog.Panel className=" relative transform overflow-hidden rounded-lg bg-white  text-left shadow-xl transition-all sm:w-full max-w-screen-md ">
        <div className="px-2 pb-4 sm:p-4">
          <div className="text-center sm:mt-3">
            <h3 className="text-left text-lg font-medium leading-6 text-gray-900">
              オプション契約編集確認
            </h3>
            <h4 className="text-left text-sm font-medium leading-6 text-gray-500 mt-2">以下の内容で登録しますか？</h4>
            {data !== undefined ? (
              <>
                <div className="overflow-x-auto mt-4 mb-4">
                  <div className="inline-block min-w-full p-1 align-middle">
                    <div className="relative overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                      <table className={`min-w-full table-fixed divide-gray-300`}>
                        <thead className="bg-gray-200 h-10">
                          <th className={headerStyle}>オプション名</th>
                          <th className={headerStyle}>契約状況</th>
                          <th className={headerStyle}>開始日</th>
                          <th className={headerStyle}>終了日</th>
                        </thead>
                        <tbody className="h-10">
                          <td className={bodyStyle}>{data.optionName}</td>
                          <td className={bodyStyle}>{data.status ? "有効" : "無効"}</td>
                          <td className={bodyStyle}>{dispDate(data.applicableStartDate)}</td>
                          <td className={bodyStyle}>{dispDate(data.applicableFinishDate)}</td>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                {data.status && data.applicableStartDate !== null && data.applicableStartDate > nowDate ? (
                  <>
                    <h4 className="text-left text-sm text-red-700">{ConstMessage.OPTION_CONTRACT_CONFIRM_START_DATE_IS_FUTURE_TEXT}</h4>
                  </>
                ) : (
                  <></>
                )}
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
        <div className="p-4 bg-gray-100">
          <div className="flex justify-end">
            <Button
              className="mx-2 mt-1 w-[132px]"
              outline
              onClick={toggle}
              children={'キャンセル'}
            />
            <Button
              className="mt-1 w-[132px]"
              children={'登録'}
              onClick={onClickSubmit}
            />
          </div>
        </div>
      </Dialog.Panel>
    </Modal>
  );
}